import { Button, DialogFooter } from '@qodo/design-system';
import { spawn } from 'utils/translations';
import { useMultiStepDialog } from '../multiStepDialogContext';
import { getProgress } from '../utils';

export const Footer = () => {
  const {
    currentStep,
    currentStepIndex,
    onCancel: cancel,
    goNext,
    goBack,
    isFirst,
    isLast,
    isNextEnabled,
    isPending,
    steps,
    earliestStepAvailable,
  } = useMultiStepDialog();

  const spawnFooter = spawn('components.multi-step-dialog');

  const progress = getProgress(currentStepIndex, steps);

  const renderBackButtonIfNeeded = () => {
    if (!currentStep.shouldShowBackButton) {
      return <></>;
    }

    const isDisabled = isFirst || earliestStepAvailable >= currentStepIndex;

    return (
      <Button
        size="sm"
        variant="outline"
        onClick={goBack}
        disabled={isDisabled}
      >
        {currentStep.backLabel ?? spawnFooter('back-label')}
      </Button>
    );
  };

  const renderCancelButtonIfNeeded = () => {
    if (!currentStep.shouldShowCancelButton) {
      return <></>;
    }

    return (
      <Button size="sm" variant="outline" onClick={cancel}>
        {currentStep.cancelLabel ?? spawnFooter('cancel-label')}
      </Button>
    );
  };

  return (
    <DialogFooter className="px-6 py-4 border-t border-border-panel-neutral flex items-center">
      <div className="flex items-center gap-2 flex-1">
        {renderCancelButtonIfNeeded()}
        {renderBackButtonIfNeeded()}
      </div>

      <div className="flex-1 flex justify-center">
        <div className="w-60 h-1 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-all"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <div className="flex-1 flex justify-end">
        <Button
          key={currentStepIndex}
          className={currentStep.nextButtonClassName}
          variant={currentStep.nextButtonVariant ?? 'primary'}
          type={currentStep.formId ? 'submit' : 'button'}
          form={currentStep.formId}
          size="sm"
          onClick={currentStep.formId ? undefined : goNext}
          loading={isPending}
          disabled={!isNextEnabled}
          icon={currentStep.nextLabelIcon}
          iconPosition="right"
          tooltip={!isNextEnabled ? currentStep.nextDisabledTooltip : undefined}
        >
          {currentStep.nextLabel ??
            (isLast ? spawnFooter('finish-label') : spawnFooter('next-label'))}
        </Button>
      </div>
    </DialogFooter>
  );
};
